import getAxiosInstance from '../../../helpers/get_axios_instance'
import { OK } from 'http-status-codes'

export class TablaDistribucionEspacioPorEspacioService {
  static async getDataTablaDistribucionPorEspacio () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_espacio_cereal_sector')
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de tabla distribucion por espacio.')
      return (data)
    })
  }

  static async getDataTablaDistribucionPorEspacioTotal () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_espacio_cereal_sector_total')
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de tabla distribucion por condición.')
      return (data)
    })
  }
}
